import { useContext, useMemo } from 'react'
import { AuthContext } from '@/context/auth-context'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import { buildSettingsSections, type SettingsSection } from '@/settings-modal/nav/settings-nav-sections'

/**
 * React adapter over the pure `buildSettingsSections` helper: pulls the role primitives from
 * AuthContext and the DRIVE_SYNC gate from feature flags, returning the role-aware section list for
 * the FE-827 SettingsModal shell.
 */
export function useSettingsModalSections(): SettingsSection[] {
  const { userAccountData } = useContext(AuthContext)
  const driveSyncEnabled = kGetFeatureFlagStatus(kFeatureFlags.DRIVE_SYNC)

  const isOrgAccount = !!userAccountData?.isOrgAccount
  const isOrgAdmin = !!userAccountData?.isOrgAdmin

  return useMemo(() => buildSettingsSections({ isOrgAccount, isOrgAdmin, driveSyncEnabled }), [isOrgAccount, isOrgAdmin, driveSyncEnabled])
}
